import { isEmpty, merge } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { ThemeProvider } from 'styled-components';
import { theme as defaultTheme } from 'decisiv-ui-utils';

import { loadBrandValues } from 'redux/ui/actions';
import { brandSelector, brandValuesSelector } from 'redux/ui/selectors';

import immutableToJS from 'utils/immutableToJS';

import configureFonts from './configureFonts';
import configureGlobalStyles from './configureGlobalStyles';

export class AppThemeProvider extends Component {
  static propTypes = {
    baseTheme: PropTypes.shape({
      animations: PropTypes.object.isRequired,
      colors: PropTypes.shape({
        base: PropTypes.object.isRequired,
        brand: PropTypes.object.isRequired,
        status: PropTypes.object.isRequired,
      }).isRequired,
      dimensions: PropTypes.object.isRequired,
      globalStyles: PropTypes.shape({
        buildGlobalStyleString: PropTypes.func.isRequired,
      }).isRequired,
      transitions: PropTypes.object.isRequired,
    }).isRequired,
    brand: PropTypes.oneOf(['decisiv', 'michelin']).isRequired,
    brandValues: PropTypes.shape({
      colors: PropTypes.object,
    }).isRequired,
    children: PropTypes.node.isRequired,
    loadBrandValues: PropTypes.func.isRequired,
  };

  static defaultProps = {
    baseTheme: defaultTheme,
  };

  state = {
    RenderComponent: null,
  };

  componentWillMount() {
    this.buildComponent(this.props);
  }

  componentDidMount() {
    this.props.loadBrandValues({ brand: this.props.brand });
  }

  componentWillUpdate(nextProps) {
    if (
      this.props.brand !== 'decisiv' &&
      isEmpty(this.props.brandValues) &&
      !isEmpty(nextProps.brandValues) &&
      this.props.brandValues !== nextProps.brandValues
    ) {
      this.buildComponent(nextProps);
    }
  }

  buildAppTheme = (baseTheme, customTheme) => merge(baseTheme, customTheme);

  shouldRenderNullComponent = (brand, brandValues) => brand !== 'decisiv' && isEmpty(brandValues);

  buildComponent = (props) => {
    const { baseTheme, brand, brandValues, children } = props;

    if (this.shouldRenderNullComponent(brand, brandValues)) {
      this.setState({ RenderComponent: () => null });
    } else {
      const appTheme = this.buildAppTheme(baseTheme, {
        colors: brandValues.colors,
      });

      configureFonts(appTheme);

      configureGlobalStyles(appTheme);

      this.setState({
        RenderComponent: () => <ThemeProvider theme={appTheme}>{children}</ThemeProvider>,
      });
    }
  };

  render() {
    const { RenderComponent } = this.state;
    return <RenderComponent />;
  }
}

function mapStateToProps(state) {
  return {
    brand: brandSelector(state),
    brandValues: brandValuesSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadBrandValues: brand => dispatch(loadBrandValues(brand)),
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), immutableToJS)(
  AppThemeProvider,
);



// WEBPACK FOOTER //
// ./setup/AppThemeProvider/index.js